import { REQUEST, SUCCESS, ERROR } from "./types";

const state = {
  groups: {
    docs: [],
    page: 1,
    limit: 1000,
    total: 0
  },
  roles: {
    docs: [],
    page: 1,
    limit: 1000,
    total: 0
  },
  policies: {
    docs: [],
    page: 1,
    limit: 1000,
    total: 0
  },
  loading: false,
  error: false,
  errorMessage: ``
}

const getters = {
  groups: state => state.groups,
  roles: state => state.roles,
  policies: state => state.policies,
  loadingState: state => state.loading,
  error: state => state.error,
  errorMessage: state => state.errorMessage
}

const actions = {
  async get({ state, commit, dispatch }, { action }) {
    if (state.loading) return
    commit(REQUEST)

    const response = await dispatch(`api`,
      {
        entity: `permission`,
        action,
        query: `?page=${state[action].page}&per_page=${state[action].limit || 10}&active=true`
      },
      { root: true }
    )

    if (response && response.status < 400) {
      commit(SUCCESS, { action, payload: response.data })
    } else {
      commit(ERROR, response?.data?.error)
    }
    return response
  },

  async delete({ state, commit, dispatch }, { action, payload }) {
    // TODO mudar para toggle
    if (state.loading) return
    commit(REQUEST)

    const response = await dispatch(`api`,
      {
        entity: `permission`,
        action: `edit_${action}`,
        params: {
          id: payload._id
        },
        payload: {
          ...payload,
          isActive: false
        }
      },
      { root: true }
    )

    if (response && response.status < 400) {
      commit(SUCCESS)
    } else {
      commit(ERROR, response?.data?.error)
    }
    return response
  }

}

const mutations = {
  [REQUEST](state) {
    state.loading = true
  },
  [SUCCESS](state, { action, payload } = {}) {
    payload && (state[action] = payload)
    state.loading = false
    state.error = false
    state.errorMessage = ``
  },
  [ERROR](state, error) {
    state.error = true
    state.errorMessage = error
    state.loading = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
